import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getBettingCenterConfig() {
    const CUSTOM_CONFIG = {
        BetView: {
            headerContainer: {
                style: {
                    padding: 8,
                },
            },
        },
    };

    return {
        custom: {
            [PALETTE_IDS.BETSLIP]: CUSTOM_CONFIG,
        },
        palette: {
            [PALETTE_IDS.BET_RECEIPT]: {
                BET_RECEIPT_BETS_LIST_CONTAINER_BG: COLOR.BRAND.BACKGROUND6,
                BET_RECEIPT_BET_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,
                BET_RECEIPT_BET_HEADER_CONTAINER_BG: COLOR.BRAND.BACKGROUND6,
                BET_RECEIPT_BET_HEADER_TEXT: {
                    fontFamily: FONT.FAMILY_SECOND,
                    color: COLOR.BRAND.ACCENT1,
                    fontWeight: FONT.WEIGHT_NORMAL,
                    fontSize: FONT.SIZE_SMALL,
                    textTransform: 'capitalize',
                },
                BET_RECEIPT_NUMBER_TEXT: `${COLOR.BRAND.FOREGROUND6}|${COLOR.BRAND.FOREGROUND3}`,
                BET_RECEIPT_DEVICE_ID_TEXT: `${COLOR.BRAND.FOREGROUND6}|${COLOR.BRAND.FOREGROUND3}`,
                BET_RECEIPT_TYPE_TEXT: `${COLOR.BRAND.FOREGROUND6}|${COLOR.BRAND.FOREGROUND3}`,
                BET_RECEIPT_RETAIN_BUTTON: {
                    SECONDARY_BUTTON_BORDER_COLOR: COLOR.BRAND.FOREGROUND6,
                    SECONDARY_BUTTON_TEXT: COLOR.BRAND.FOREGROUND6,
                },
            },
            [PALETTE_IDS.BETTING_CENTER]: {
                BETTING_CENTER_TAB_BUTTON_SELECTED_BG: COLOR.BRAND.BACKGROUND6,
                BETTING_CENTER_TAB_BUTTON_BG: COLOR.BRAND.BACKGROUND1,
                BETTING_CENTER_TAB_BUTTON_TEXT: {
                    color: COLOR.BRAND.BACKGROUND7,
                    fontWeight: FONT.WEIGHT_NORMAL,
                },
                BETTING_CENTER_TAB_BUTTON_SELECTED_TEXT: {
                    color: COLOR.BRAND.BACKGROUND1,
                    fontWeight: FONT.WEIGHT_NORMAL,
                },
                BETTING_CENTER_CONTENT_CONTAINER_BG: COLOR.BRAND.BACKGROUND6,

                BETTING_CENTER_BET_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,
                BETTING_CENTER_BET_CONTAINER_BORDER_RADIUS: 0,
            },
            [PALETTE_IDS.BETSLIP]: {
                BETSLIP_BET_TYPE_SELECTOR_CONTAINER_BG: COLOR.BRAND.BACKGROUND6,
                BETSLIP_BET_TYPE_SELECTOR: {
                    PIVOT_TEXT: {
                        fontSize: FONT.SIZE_MEDIUM,
                        color: COLOR.BRAND.FOREGROUND6,
                    },
                    PIVOT_SELECTED_TEXT: {
                        fontSize: FONT.SIZE_MEDIUM,
                        color: COLOR.BRAND.FOREGROUND6,
                    },
                },
                BETSLIP_REMOVE_BET_BUTTON: {
                    CLOSE_BUTTON_ICON_COLOR: COLOR.BRAND.FOREGROUND2,
                },

                BETSLIP_BANKERS_BET_BUTTON: {
                    TOGGLE_BUTTON_BORDER_RADIUS: 0,
                },

                BETSLIP_BB_BET_ICON_COLOR: COLOR.BRAND.ACCENT3,
                BETSLIP_BEST_ODDS_GUARANTEED_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
                BETSLIP_BB_BET_TITLE_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },

                BETSLIP_REMOVE_ALL_BUTTON_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,
                BETSLIP_REMOVE_ALL_BUTTON: {
                    TERTIARY_BUTTON_TEXT: {
                        color: COLOR.BRAND.FOREGROUND2,
                        fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    },
                },

                BETSLIP_TEASERS_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,

                BETSLIP_BETS_LIST_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,

                BETSLIP_EMPTY_CONTENT_MESSAGE: {
                    EMPTY_CONTENT_MESSAGE_TEXT: {
                        color: COLOR.BRAND.FOREGROUND6,
                        fontSize: FONT.SIZE_XSMALL,
                    },
                },

                // Freebets
                BETSLIP_FREE_BETS_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,
                BETSLIP_FREE_BETS_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    textTransform: 'capitalize',
                },
                BETSLIP_FREE_BETS_HEADER_ROTATION_ICON_COLOR: COLOR.BRAND.ACCENT3,
                // settings
                BETSLIP_SETTINGS_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,
                BETSLIP_SETTINGS_BUTTON: {
                    TERTIARY_BUTTON_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
                },
                // Total info
                BETSLIP_BET_POTENTIAL_RETURNS_TEXT: COLOR.BRAND.FOREGROUND2,
                BETSLIP_PLACE_BET_TOTAL_INFO_CONTAINER_BG: COLOR.BRAND.BACKGROUND6,
                // Sliding betslip
                SLIDING_BETSLIP_BUTTON_BASE_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    fontFamily: FONT.FAMILY_SECOND,
                },
                SLIDING_BETSLIP_BUTTON_HIGHLIGHTED_BG: COLOR.BRAND.CTA1,
            },
            [PALETTE_IDS.NUMERIC_KEYPAD]: {
                KEYPAD_CONTAINER_BG: COLOR.BRAND.BACKGROUND6,
                KEYPAD_COMPACT_CONTAINER_BG: COLOR.BRAND.BACKGROUND6,
                KEYPAD_INCREASE_BUTTON_BG: COLOR.BRAND.BACKGROUND5,
                KEYPAD_BUTTON: {
                    TOGGLE_BUTTON_BORDER_RADIUS: 4,
                    TOGGLE_BUTTON_BORDER_COLOR: COLOR.BRAND.FOREGROUND6,
                    TOGGLE_BUTTON_BG: COLOR.BRAND.BACKGROUND6,
                },
                KEYPAD_COMPACT_BUTTON: {
                    TOGGLE_BUTTON_BORDER_RADIUS: 4,
                    TOGGLE_BUTTON_BG: COLOR.BRAND.BACKGROUND6,
                    TOGGLE_BUTTON_TEXT: {
                        color: COLOR.BRAND.FOREGROUND6,
                        textTransform: 'uppercase',
                    },
                },
            },
            [PALETTE_IDS.YOUR_BETS]: {
                OPEN_BET_LIVE_EVENT_TIMING_STATUS: {
                    EVENT_TIMING_LIVE_TEXT: {
                        color: COLOR.BRAND.FOREGROUND1,
                        fontWeight: FONT.WEIGHT_NORMAL,
                    },
                    EVENT_TIMING_UPCOMING_TEXT: COLOR.BRAND.FOREGROUND1,
                },

                YOUR_BETS_EMPTY_CONTENT_MESSAGE: {
                    EMPTY_CONTENT_MESSAGE_TEXT: {
                        color: `${COLOR.BRAND.FOREGROUND2}|${COLOR.BRAND.FOREGROUND6}`,
                        fontSize: FONT.SIZE_XSMALL,
                    },
                },
                OPEN_BET_BASE_INFO: {
                    BET_FUNDS_INFO: {
                        BET_FUNDS_INFO_TEXT: COLOR.BRAND.FOREGROUND1,
                        BET_FUNDS_INFO_EMPHASIZED_TEXT: COLOR.BRAND.FOREGROUND1,
                        BET_FUNDS_INFO_MEDIUM_TEXT: COLOR.BRAND.FOREGROUND1,
                    },
                },
            },
            [PALETTE_IDS.OVERASK]: {
                OVERASK_REVIEWING_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,
                OVERASK_REVIEWING_TEXT: COLOR.BRAND.FOREGROUND1,

                OVERASK_TIMER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND7,
                    fontWeight: FONT.WEIGHT_NORMAL,
                },
                OVERASK_BET_OFFER_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,
                OVERASK_TRADER_BET_OFFER_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,
                OVERASK_BET_OFFER_STATUS_TITLE_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontSize: FONT.SIZE_LARGE,
                    textTransform: 'capitalize',
                },
                OVERASK_BET_OFFER_HEADER_BG: COLOR.BRAND.BACKGROUND6,
                OVERASK_BET_OFFER_HEADER_TEXT: {
                    fontFamily: FONT.FAMILY_SECOND,
                    color: COLOR.BRAND.ACCENT2,
                    fontWeight: FONT.WEIGHT_NORMAL,
                    fontSize: FONT.SIZE_XSMALL,
                    textTransform: 'capitalize',
                },
                OVERASK_BET_OFFER_HEADER_CHECK_BUTTON_BG: COLOR.BRAND.ACCENT2,
                OVERASK_BET_OFFER_HEADER_CHECK_BUTTON_ICON_COLOR: COLOR.BRAND.FOREGROUND5,

                OVERASK_BET_OFFER_STAKE_PER_LINE_TEXT: COLOR.BRAND.FOREGROUND2,
            },
            [PALETTE_IDS.QUICK_BETSLIP]: {
                QUICK_BETSLIP_BET_STAKE_INPUT: {
                    STAKE_INPUT_TEXT: COLOR.BRAND.FOREGROUND6,
                },
                QUICK_BETSLIP_BET_BASE_INFO: {
                    BET_SELECTION_NAME_TEXT: COLOR.BRAND.FOREGROUND6,
                    BET_MARKET_NAME_TEXT: COLOR.BRAND.FOREGROUND6,
                    BET_EVENT_NAME_TEXT: COLOR.BRAND.FOREGROUND6,
                },
                QUICK_BETSLIP_CONTAINER_BG: COLOR.BRAND.BACKGROUND6,
                QUICK_BETSLIP_REMOVE_BET_BUTTON: {
                    CLOSE_BUTTON_ICON_COLOR: COLOR.BRAND.FOREGROUND6,
                },
                QUICK_BETSLIP_BET_RECEIPT: {
                    BET_RECEIPT_BET_CONTAINER_BG: COLOR.BRAND.BACKGROUND6,
                    BET_RECEIPT_BET_BASE_INFO: {
                        BET_SELECTION_NAME_TEXT: COLOR.BRAND.BACKGROUND5,
                        BET_EVENT_NAME_TEXT: COLOR.BRAND.BACKGROUND5,
                        BET_MARKET_NAME_TEXT: COLOR.BRAND.BACKGROUND5,
                    },
                },
                QUICK_BETSLIP_BET_RECEIPT_PLACED_BET_DATE_TEXT: COLOR.BRAND.FOREGROUND7,
                QUICK_BETSLIP_ODDS_BOOST_BANNER: {
                    ODDS_BOOSTS_CONTAINER_BG: COLOR.BRAND.BACKGROUND6,
                    ODDS_BOOSTS_ACCENT_COLOR: COLOR.BRAND.ACCENT1,
                    ODDS_BOOSTS_INFO_ICON_COLOR: COLOR.BRAND.FOREGROUND7,
                    ODDS_BOOSTS_ICON_COLOR: COLOR.BRAND.FOREGROUND7,
                },
            },
        },
    };
}
